import moment from "moment";

export const useTrainingContainer = (training) => {
  return {
    ...training,
    startTime: moment(training.start).format("HH:mm"),
    endTime: moment(training.start, "YYYY-mm-dd HH:mm")
      .add(training.duration, "minutes")
      .format("HH:mm"),
    date: moment(training.start).format("DD MMMM"),
    training: training?.training?.map((el) => ({
      ...el,
      state_training_children: {
        ...el.state_training_children,
        name: el.state_training_children.id === 2 || 3 ? "Был" : "Не был",
      },
    })),
  };
};
